import api from ".";

export async function getResidential() {
  const response = await api.get("/residential");

  return response.data.residentials;
}
